import { Colors } from '@zippeditoolsjs/design-tokens';

export const COLORS = {
  stock: {
    color: '#349E15',
    focusedColor: '#ABF096',
    color2: '#143f07',
    text: '#fff',
  },
  stockout: {
    color: '#D80A3B',
    focusedColor: '#EA99AC',
    color2: '#60051b',
    text: '#fff',
  },
  spread_to_fill: {
    color: '#DB9105',
    focusedColor: '#FFD8AD',
    color2: '#7a6235',
    text: '#000',
  },
  price_difference: {
    color: '#FFD740',
    focusedColor: '#FFEDAB',
    color2: '#b79d00',
    text: '#000',
  },
  hua: {
    color: '#4065F6',
    focusedColor: '#91C8E4',
    color2: '#2E4890',
    text: '#fff',
  },
  promotion: {
    color: '#14b8a6',
    focusedColor: '#97FFF6',
    color2: '#0c685e',
    text: '#fff',
  },
  inactive_promotion: {
    color:  '#5616eaff',
    focusedColor: '#270f61ff',
    color2: '#35177bff',
    text: '#fff',
  },
};

export function colorBasedOnTheme(theme, object) {
  let isDarkTheme = theme.palette.type === 'dark' ? true : false;
  let color = '';

  switch (object) {
    // Color
    case 'color':
      color = isDarkTheme ? 'primary.contrastText' : 'common.dark';
      break;
    case 'color-darkTheme':
      color = 'primary.contrastText';
      break;
    // Background
    case 'bgcolor-darkTheme':
      color = isDarkTheme ? 'paper.main' : 'primary.main';
      break;
    // case 'bgcolor-white':
    //   color = isDarkTheme ? 'paper.main' : 'common.white';
    //   break;
    // Effects
    case 'bgcolor-hover':
      color = isDarkTheme ? 'rgba(98, 98, 130, 0.1)' : 'rgba(0, 0, 0, 0.04)';
      break;
    case 'bgcolor-hover-darkTheme':
      color = 'rgba(98, 98, 130, 0.1)';
      break;
    default:
      break;
  }

  return color;
}

export function colorBasedOnAlert(alert) {
  let color = '';

  switch (alert) {
    case 'in_stock':
      color = 'rgba(0, 179, 24, 1)'
      break
    case 'price_difference':
      color = 'rgba(255, 215, 64, 1)'
      break;
    case 'spread_to_fill':
      color = 'rgba(255 ,164 ,0, 1)'
      break;
    case 'stockout':
    case 'zero_stock':
    case 'shelf_out':
      color = 'rgba(255, 0, 66, 1)'
      break;
    case 'inactive_promotion':
      color = 'rgba(136, 70, 207, 1)'
      break;
    default:
      color = 'rgba(255, 0, 204, 1)'
      break;
  }
  return color
}

export function highlightedProductColor() {
  return 'cyan'
}

export function colorBasedOnTaskCompletion(completed) {
  let color = '';

  if (completed) {
    color = 'success.light';
  } else {
    color = 'error.light'
  }
  return color
}

export function mapBackgroundColor() {
  return 'rgba(196, 196, 217, 255)'
}

// Fill applied to the fixtures of the enhanced store map, as the [R, G, B]
// channels that ImageData expects.
export function enhancedMapFixtureColor() {
  const hex = Colors.muted
  return [1, 3, 5].map(channel => parseInt(hex.slice(channel, channel + 2), 16))
}

export function checkColor(product) {
  let color = COLORS['stock'].color;
  if (product.stockout) color = COLORS['stockout'].color;
  if (product.spread_to_fill) color = COLORS['spread_to_fill'].color;
  else if (product.price_difference) color = COLORS['price_difference'].color;
  else if (!product.landmark_type && product.hasOwnProperty('pixel_z')) color = COLORS['promotion'].color;
  else if (product.landmark_type) color = COLORS['hua'].color;

  return color;
};


export const checkIconsName = product => {
  const iconNames = [];
  if (product.hasOwnProperty('stockout')) {
    if (product.stockout) iconNames.push('stock-out');
    else if (product.spread_to_fill) iconNames.push('stock-out');
    if (product.price_difference) iconNames.push('price-difference');
    if (product.landmark_type) iconNames.push('location');
    if (iconNames.length === 0) iconNames.push('stock');
  } else {
    iconNames.push('promotion');
  }
  return iconNames;
};

// Checks any of the product's alerts against the active filter Set.
// Replaces single-type matching via getCoordAlertName, which hid multi-alert elements.
export const matchesSelectedStatus = (product, selectedStatus) => {
  if (!selectedStatus) return true;
  return handleCoordAlertInfo(product).some(alert => selectedStatus.has(alert.title));
};

export const isAlertCountUnknown = (alertName, priceDifferencesUnavailable) =>
  alertName === 'price_difference' && priceDifferencesUnavailable === true;

export const shouldShowAlertPill = (
  alertName,
  alertCount,
  priceDifferencesUnavailable,
) => alertCount > 0 || isAlertCountUnknown(alertName, priceDifferencesUnavailable);

// TODO: preguntar si quieres que los spread-to-fill salgan con los in-stock
export const handleCoordAlertInfo = product => {
  const alertColors = [];

  if (!product.stockout && !product.landmark_type && !product.spread_to_fill && product.detection_id) {
    alertColors.push({ colorInfo: COLORS['stock'], iconName: 'stock', title: 'stock' });
  }
  if (product.spread_to_fill) {
    alertColors.push({ colorInfo: COLORS['spread_to_fill'], iconName: 'stock-out', title: 'spread_to_fill' });
  } else if (product.stockout) {
    alertColors.push({ colorInfo: COLORS['stockout'], iconName: 'stock-out', title: 'stockout' });
  }
  if (product.price_difference) alertColors.push({ colorInfo: COLORS['price_difference'], iconName: 'price-difference', title: 'price_difference' });
  if (product.landmark_type) alertColors.push({ colorInfo: COLORS['hua'], iconName: 'location', title: 'hua' });

  if (product.inactive_promotion) alertColors.push({ colorInfo: COLORS['inactive_promotion'], iconName: 'inactive-promo', title: 'inactive_promotion' });
  else if (product.promotion_value || product.isPromotion) alertColors.push({ colorInfo: COLORS['promotion'], iconName: 'pricetag', title: 'promotion' })
  return alertColors;
}

/**
 * Returns a color from the theme palette based on the contact level.
 * @param  	{String} 				level 	The contact level ('client', 'region', 'store').
 * @param  	{Object} 				theme 	The MUI theme object.
 * @return  {String}						The color string from the theme palette.
 */
export const contactLevelColor = (level, theme) => {
  let color = '';
  switch (level) {
    case "client":
      color = theme.palette.pastelEmerald.light;
      break;
    case "region":
      color = theme.palette.pastelViolet.light;
      break;
    case "store":
      color = theme.palette.pastelSky.light;
      break;
    default:
      break;
  }
  return color;
}
